export const formatRelativeDate = (dateString) => {
    if (!dateString) {
        return 'Unknown date'
    }

    const date = new Date(dateString)

    // Check if date is valid
    if (isNaN(date.getTime())) {
        return 'Invalid date'
    }

    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const yesterday = new Date(today)
    yesterday.setDate(yesterday.getDate() - 1)

    const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate())

    // Format time (default to 12:34PM if time not available)
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const hasValidTime = !isNaN(hours) && !isNaN(minutes) && (hours !== 0 || minutes !== 0)

    let timeString
    if (hasValidTime) {
        const period = hours >= 12 ? 'PM' : 'AM'
        const displayHours = hours % 12 || 12
        const displayMinutes = minutes.toString().padStart(2, '0')
        timeString = `${displayHours}:${displayMinutes}${period}`
    } else {
        timeString = '12:34PM'
    }

    // Check if today or yesterday
    if (dateOnly.getTime() === today.getTime()) {
        return `Today, ${timeString}`
    } else if (dateOnly.getTime() === yesterday.getTime()) {
        return `Yesterday, ${timeString}`
    } else {
        // Format as DD MMM YYYY
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        const day = date.getDate()
        const month = months[date.getMonth()]
        const year = date.getFullYear()
        return `${day} ${month} ${year}, ${timeString}`
    }
}

// Helper function to create date from MongoDB ObjectId
export const getDateFromObjectId = (objectId) => {
    // Validate objectId
    if (!objectId || typeof objectId !== 'string' || objectId.length < 8) {
        console.warn('Invalid ObjectId provided:', objectId)
        return null
    }

    // A MongoDB Object Id is a 12-byte object that consists of:
    // - 4 bytes for timestamp (in seconds since unix epoch)
    // - 5 bytes for machine/process random value
    // - 3 bytes for client side counter

    // Get the first 4 bytes to a timestamp
    const fourByteData = objectId.substring(0, 8)

    // Convert the 4 bytes to an integer
    const integerData = parseInt(fourByteData, 16)

    // Validate parsed data
    if (isNaN(integerData)) {
        console.warn('Failed to parse ObjectId timestamp:', objectId)
        return null
    }

    // Convert the integer data to seconds since unix epoch
    const secondsSinceUnixEpoch = integerData * 1000

    // Convert the seconds since unix epoch to a date
    const date = new Date(secondsSinceUnixEpoch)

    // Return the date
    return date
}

// Safe date formatter that handles created_at field or ObjectId
export const formatCreatedDate = (item) => {
    // Try created_at field first
    if (item.created_at) {
        return formatRelativeDate(item.created_at)
    }

    // Try to extract from ObjectId
    if (item.id) {
        const date = getDateFromObjectId(item.id)
        if (date) {
            return formatRelativeDate(date)
        }
    }

    // Fallback
    return 'Unknown date'
}

// Format date as YYYY-MM-DD
export const formatDateYYYYMMDD = (item) => {
    let date = null

    // Try created_at field first
    if (item.created_at) {
        date = new Date(item.created_at)
    } else if (item.id) {
        // Try to extract from ObjectId
        date = getDateFromObjectId(item.id)
    }

    // If we have a valid date, format it
    if (date && !isNaN(date.getTime())) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
    }

    // Fallback to current date
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}